import { SelectProps } from 'antd';
import { useEffect } from 'react';
import { extractValueOptionList } from '../../utils/extractValueOptionList';
import { getFilteredSelectedValues } from '../../utils/getFilteredSelectedValues';
import { SelectOption } from '../SelectInput';

export interface IUseFilterSelectValuesOnOptionsChangeOptions {
  options: SelectOption[] | null | undefined;
  mode: SelectProps['mode'];
  value: string[] | string;
  onChange: (value: any) => void;
  withDisabled?: boolean;
}

/**
 * Nel caso cambino le options (e.g. async select) e il valore non
 * sia presente tra le opzioni disponibili, allora devo resettare il campo.
 * Anche se qualche option diventa disabled, devo rimuoverla dalle opzioni.
 */
export function useFilterSelectValuesOnOptionsChange(
  input: IUseFilterSelectValuesOnOptionsChangeOptions,
) {
  const { options, mode, value, onChange, withDisabled = false } = input;
  useEffect(() => {
    // Saltiamo in caso di options undefined
    if (options == null) return;

    const optionListValues = extractValueOptionList(options, { withDisabled });

    // Se il valore non è presente tra le opzioni disponibili, allora lo resetto
    const result = getFilteredSelectedValues(value, mode, optionListValues);

    if (result.changed) {
      console.log(`[useFilterSelectValuesOnOptionsChange] Resetting value from ${String(value)} to ${String(result.value)}`); // prettier-ignore
      onChange(result.value);
    }
  }, [mode, onChange, options, value, withDisabled]);
}
